import { UrlParameter } from "@closerplatform/spinner-openapi";

export const applyUrlParameter = (url: string, parameter: UrlParameter, value: string): string =>
    url.replace(`{{${parameter}}}`, value);
